import { rowsPerPageOptions } from "utils/constants";

const RowsPerPageSelector = ({ value, onChange }) => {
	return (
		<div className="flex items-center gap-2">
			<label
				htmlFor="rowsPerPage"
				className="text-sm font-medium text-gray-700"
			>
				Show:
			</label>
			<select
				id="rowsPerPage"
				value={value}
				onChange={(e) => onChange(parseInt(e.target.value))}
				className="h-11 w-16 border border-gray-300 rounded-lg pl-3 bg-white pr-2 text-sm focus:outline-none focus:border-gray-500"
			>
				{rowsPerPageOptions.map((option) => (
					<option
						key={option}
						value={option}
					>
						{option}
					</option>
				))}
			</select>
			<span className="text-sm text-gray-600">per page</span>
		</div>
	);
};

export default RowsPerPageSelector;
